import { showConfirmModal, showDynamicDialogOn } from '@/lib/modals';
import { getCurrentInstance } from 'vue';

// Get the parameter types from the show method of VueJsModal
export function useModal() {
  const { proxy } = getCurrentInstance();

  if (!proxy) {
    throw new Error(
      'useModal must be called within a component setup function'
    );
  }

  const modal = proxy.$modal;

  const show = (...args: Parameters<typeof modal.show>): void => {
    modal.show(...args);
  };

  const hide = (...args: Parameters<typeof modal.hide>): void => {
    modal.hide(...args);
  };

  async function confirm({
    title,
    message,
    acceptText,
    cancelText,
    acceptColor,
  }: {
    title: string;
    message: string;
    acceptText?: string;
    cancelText?: string;
    acceptColor?: string;
  }) {
    return await showConfirmModal(
      modal,
      title,
      message,
      acceptText,
      cancelText,
      acceptColor
    );
  }

  function showDynamicDialog<T>(
    component,
    props,
    name = 'modal',
    options: Record<string, unknown> = {}
  ) {
    return showDynamicDialogOn<T>(modal, component, props, name, options);
  }

  async function dialogSubmit(modalId: string, value: any) {
    return await (<Function>proxy.$parent.$listeners.submit)(value);
  }

  return {
    show,
    hide,
    confirm,
    dialogSubmit,
    showDynamicDialog,
  };
}
